export default {
  setTagList(state, responseData) {
    state.tagList = responseData;
  },

  setCategoryList(state, responseData) {
    state.categoryList = responseData;
  },

  setProductCategoryList(state, responseData) {
    state.productCategoryList = responseData;
  },

  setPromotionList(state, list) {
    state.promotionList = [...state.promotionList, ...list];
  },

  setServiceAreaList(state, responseData) {
    state.serviceAreaList = responseData;
  },

  initList(state) {
    state.condition.page = 1;
    state.pageInfo.totalPage = 2;
    state.promotionList = [];
  },

  setList(state, list) {
    state.list = [...state.list, ...list];
  },

  setPage(state, page = 1) {
    state.condition.page = page;
  },

  setTotalPage(state, totalPage = 2) {
    state.totalPage = totalPage;
  },

  setPageInfo(state, pageInfo) {
    state.pageInfo = pageInfo;
  },

  setCacheMeta(state, cacheMeta = {}) {
    state.cacheMeta = {
      ...state.cacheMeta,
      ...cacheMeta
    };
  },

  setIsExist: (state, isExist) => {
    state.isExist = isExist;
  },

  setStoreList: (state, list) => {
    state.storeList = list;
  },

  purgeAll: (state) => {
    state.isExist = false;
    state.tagList = [];
    state.categoryList = [];
    state.productCategoryList = [];
    state.storeList = [];
    state.promotionList = [];
    state.serviceAreaList = [];
    state.pageInfo = {
      page: 1,
      totalPage: 2,
      limit: 10
    };
    state.cacheMeta = {
      tagListFetchedAt: 0,
      categoryListFetchedAt: 0,
      locationFetchedAt: 0,
      locationKey: ''
    };
  }
};
